// extracted by mini-css-extract-plugin
module.exports = {"secondary":"buttonStyles__secondary--1Nu2T","iconRight":"buttonStyles__iconRight--ZXhao"};